import React, { useContext, useState, useEffect } from "react"
import {
  Main,
  RightSide,
  PriceBox,
  BottomDescription,
  CenterDescription,
  TopDescription,
  GridPriceBox,
  StyledLink,
  StyledLinkList,
} from "./style"
import { GoldButton } from "../../../SearchComponent/style"
import flatImage from "../../../../images/flat-image.jpg"
import { ViewContext } from "../../../../contexts/ViewContext"
import { useStaticQuery, graphql, Link } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"

const SingleFlat = ({
  title,
  image,
  urlId,
  price,
  transaction,
  pricePerBuildingMeter,
  pricePerLandMeter,
  description,
  address,
  floorage,
}) => {
  const [displayType] = useContext(ViewContext)
  const isBrowser = typeof window !== "undefined"
  const intl = useIntl()
  const [queryData, setQueryData] = useState({})

  const query = useStaticQuery(graphql`
    query SingleFlatQuery {
      polish: contentfulSearch(node_locale: { eq: "pl-PL" }) {
        checkOffer
      }
      english: contentfulSearch(node_locale: { eq: "en-US" }) {
        checkOffer
      }
    }
  `)

  useEffect(() => {
    if (isBrowser) {
      if (intl.locale === "en") {
        setQueryData(query.english)
      }
      if (intl.locale === "pl") {
        setQueryData(query.polish)
      }
    }
  }, [intl])

  const handleHistory = urlId => {
    const id = urlId.split("-").slice(-1)[0]
    window.location.href = `/oferta/${urlId}`
    window.history.pushState(
      "",
      "",
      window.location.pathname + window.location.search + "#" + id
    )

    // window.history.pushState("", document.title)
  }

  const simplifiedId = "flat_" + urlId.split("-").slice(-1)[0]

  if (displayType === "grid")
    return (
      <StyledLink
        onClick={e => handleHistory(urlId, e)}
        to={`/oferta/${urlId}`}
      >
        <Main id={simplifiedId} displayType={displayType}>
          <img
            src={image ? image : flatImage}
            alt="zdjęcie"
            loading="lazy"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = flatImage
            }}
          />

          <p>{title}</p>
          <p>{address}</p>
          <GridPriceBox>
            <p>
              {Intl.NumberFormat("pl").format(Math.round(floorage))} m
              <sup>2</sup>
            </p>
            <p>
              {Intl.NumberFormat("pl").format(price)}
              {transaction === "rent" ? " PLN/mc" : " PLN"}
            </p>
          </GridPriceBox>
        </Main>
      </StyledLink>
    )
  else
    return (
      <StyledLinkList
        onClick={e => handleHistory(urlId, e)}
        to={`/oferta/${urlId}`}
      >
        <Main
          id={simplifiedId}
          onClick={() => handleHistory(urlId)}
          displayType={displayType}
        >
          <img
            src={image ? image : flatImage}
            alt="zdjęcie"
            loading="lazy"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = flatImage
            }}
          />

          <RightSide>
            <TopDescription>
              <p>{title}</p>
              <p>{address}</p>
            </TopDescription>
            <CenterDescription>
              <p>{description}</p>
            </CenterDescription>
            <BottomDescription>
              <PriceBox>
                <p>
                  {Intl.NumberFormat("pl").format(Math.round(floorage))} m
                  <sup>2</sup>
                </p>
                <p>
                  {Intl.NumberFormat("pl").format(price)}
                  {transaction === "rent" ? " PLN/mc" : " PLN"}
                </p>
              </PriceBox>

              <GoldButton>{queryData.checkOffer}</GoldButton>
            </BottomDescription>
          </RightSide>
        </Main>
      </StyledLinkList>
    )
}

export default SingleFlat
